import ComponentManager from '@/Management/ComponentManager';
import Window from '@/Controls/Window';
import TwoFactorTokenDialogWindowViewModel from '@/Components/TwoFaktorAuth/TokenDialog/TwoFactorTokenDialogWindowViewModel';
import layout from './TwoFactorTokenDialogWindow.html?raw';
export default class TwoFactorTokenDialogWindow extends Window {
    /**
     * @override
     */
    public viewModel: TwoFactorTokenDialogWindowViewModel;

    constructor(viewModel: TwoFactorTokenDialogWindowViewModel) {
        const $element = $('<div>').addClass('two-fa-token-dialog-wrapper');
        super(viewModel, $element);

        this.applyTemplate(layout, $element);
    }

    /**
     * @override
     */
    protected onActivate(event: any): void {
        super.onActivate(event);

        this.focusTokenTextBox();
    }

    private focusTokenTextBox(): void {
        const $input = this.element?.find('.token-textbox > input');
        if (!$input?.length) {
            return;
        }

        $input.focus();
    }

    /**
     * @override
     */
    public getElementToAppended(): JQuery<HTMLElement> {
        return $('[data-region=Modal]');
    }
}

ComponentManager.setControl('TwoFactorTokenDialogWindow', TwoFactorTokenDialogWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');